import React, { useEffect, useRef } from "react";
import Graph from "./components/Graph";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useGraphLoader } from "./hooks/useGraphLoader";
import PlotSizePopUp from "./components/PlotSizePopUp";
import BHKPresetStrip from "./components/BHKPresetStrip";
import { useSelector, useDispatch } from "react-redux";
import { updatePlotWidth, updatePlotHeight } from "../../redux/features/nodes";
import { Box, Typography } from "@mui/material";
import { RootState } from "../../redux/store";
import { setFromDocuments } from "../../redux/features/graph/graph.slice";

const InputGraphEditorPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const bhkType = state?.bhkType;
  const editorType = state?.editorType;

  const graphRef = useRef<HTMLDivElement>(null);

  const isClicked = useSelector((state: RootState) => state.newFile.isClicked);

  useGraphLoader(state);

  useEffect(() => {
    dispatch(setFromDocuments(false));
  }, [dispatch]);

  useEffect(() => {
  dispatch(updatePlotWidth(0));
  dispatch(updatePlotHeight(0));
}, []);

  useEffect(() => {
    document.title = "InputGraphEditor";

    const handleWheel = function (e: any) {
      if (
        e.ctrlKey &&
        graphRef.current &&
        !graphRef.current.contains(e.target)
      ) {
        e.preventDefault();
      }
    };

    const handleTouchMove = function (e: any) {
      if (
        e.touches.length > 1 &&
        graphRef.current &&
        !graphRef.current.contains(e.target)
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <div>
      {isClicked && <PlotSizePopUp />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#FF9A56",
          borderRadius: "8px",
          padding: "10px 17px",
          position: "fixed",
          zIndex: 2000,
          left: "14.5px",
          top: "18.5px",
          // boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        }}
      >
        <Box
  onClick={() => {
    if (editorType === "housing") {
      navigate("/home?editorType=housing");
    } else if (editorType === "newinputeditor") {
      navigate("/home?editorType=newinputeditor");
    } else {
      navigate("/home?editorType=blank");
    }
  }}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            "&:hover": { opacity: 0.8 },
          }}
        >
          <ArrowBackIcon htmlColor="#FBE5C6" sx={{ padding: "3px" }} />
          <Typography
            sx={{
              pl: "5px",
              color: "#FBE5C6",
              fontFamily: "Poppins",
              fontSize: "16px",
              fontWeight: 500,
            }}
          >
            Back
          </Typography>
        </Box>
      </Box>

      <div
        ref={graphRef}
        style={isClicked ? { filter: "blur(5px)", pointerEvents: "none" } : {}}
      >
        <Graph />
{editorType === "housing" && (
  <BHKPresetStrip />
)}
      </div>
    </div>
  );
};

export default InputGraphEditorPage;
